/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneNavigation from 'sites/allas/components/standalone/Navigation';

export const DynamicStandaloneNavigation = StandaloneNavigation;
export type DynamicStandaloneNavigationProps = PropsFromComponent<typeof StandaloneNavigation>;

export const DynamicStandaloneNavigationWith = (extras: DynamicStandaloneExtras): typeof StandaloneNavigation => {
    return function DynamicStandaloneNavigation(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Navigation');
        return <StandaloneNavigation {...mergeProps({ options: { theme } }, props)} />;
    }
}